(function () {
  'use strict';
 
  const BUNDLE_SIZE      = 3;
  const DISCOUNT_PERCENT = 15;
 
  const state = {
    selected:  [],
    isLoading: false,
  };
 
  const $ = (sel, p = document) => p.querySelector(sel);
  const $$ = (sel, p = document) => [...p.querySelectorAll(sel)];
  const formatMoney = (cents) =>
    (cents / 100).toLocaleString('en-PK', { style: 'currency', currency: 'PKR' });
 
  /* ── CACHE ELEMENTS ── */
  let elGrid, elSlots, elProgressFill, elProgressText,
      elOriginalPrice, elDiscountRow, elDiscountAmount, elFinalPrice,
      elAddToCart, elLoader, elCTAText, elError, elErrorText,
      elMobileCount, elMobilePrice, elMobileCartBtn;
 
  function cacheElements() {
    elGrid           = $('#hbProductGrid');
    elSlots          = $$('#hbSlots .hb-slot');
    elProgressFill   = $('#hbProgressFill');
    elProgressText   = $('#hbProgressText');
    elOriginalPrice  = $('#hbOriginalPrice');
    elDiscountRow    = $('#hbDiscountRow');
    elDiscountAmount = $('#hbDiscountAmount');
    elFinalPrice     = $('#hbFinalPrice');
    elAddToCart      = $('#hbAddToCart');
    elLoader         = $('#hbLoader');
    elCTAText        = elAddToCart ? $('#hbAddToCart .hb-cta__text') : null;
    elError          = $('#hbError');
    elErrorText      = $('#hbErrorText');
    elMobileCount    = $('#hbMobileCount');
    elMobilePrice    = $('#hbMobilePrice');
    elMobileCartBtn  = $('#hbMobileCartBtn');
  }
 
  /* ══════════════════════════════════════════
     POPUP
  ══════════════════════════════════════════ */
 
  function createPopupHTML() {
    const el = document.createElement('div');
    el.id = 'hbPopupOverlay';
    el.innerHTML = `
      <div class="hb-popup" id="hbPopup" role="dialog" aria-modal="true">
        <button class="hb-popup__close" id="hbPopupClose" aria-label="Close">&times;</button>
 
        <div class="hb-popup__img-wrap">
          <img id="hbPopupImg" src="" alt="" />
        </div>
 
        <div class="hb-popup__body">
          <p class="hb-popup__vendor" id="hbPopupVendor"></p>
          <h3 class="hb-popup__title"  id="hbPopupTitle"></h3>
          <p class="hb-popup__price"   id="hbPopupPrice"></p>
 
          <!-- COLOR -->
          <div class="hb-popup__section" id="hbColorSection">
            <p class="hb-popup__label">
              Color: <span class="hb-popup__selected-label" id="hbSelectedColor">—</span>
            </p>
            <div class="hb-popup__options" id="hbColorOptions"></div>
          </div>
 
          <!-- SIZE -->
          <div class="hb-popup__section" id="hbSizeSection" style="display:none;">
            <p class="hb-popup__label">
              Size: <span class="hb-popup__selected-label" id="hbSelectedSize">—</span>
            </p>
            <div class="hb-popup__options" id="hbSizeOptions"></div>
          </div>
 
          <p class="hb-popup__loading" id="hbPopupLoading">Loading variants…</p>
 
          <button class="hb-popup__cta" id="hbPopupAdd" disabled>
            Select color &amp; size
          </button>
        </div>
      </div>
    `;
    document.body.appendChild(el);
 
    el.addEventListener('click', (e) => { if (e.target === el) closePopup(); });
    $('#hbPopupClose').addEventListener('click', closePopup);
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closePopup(); });
  }
 
  /* popup state */
  let popupProduct     = null;
  let allVariants      = [];
  let selectedColor    = null;
  let selectedSize     = null;
  let selectedVariant  = null;
 
  async function openPopup(card) {
    const overlay = $('#hbPopupOverlay');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
 
    /* reset */
    popupProduct    = null;
    allVariants     = [];
    selectedColor   = null;
    selectedSize    = null;
    selectedVariant = null;
 
    $('#hbPopupImg').src            = card.dataset.productImage;
    $('#hbPopupTitle').textContent  = card.dataset.productTitle;
    $('#hbPopupVendor').textContent = card.dataset.productVendor || '';
    $('#hbPopupPrice').textContent  = '';
    $('#hbSelectedColor').textContent = '—';
    $('#hbSelectedSize').textContent  = '—';
    $('#hbColorOptions').innerHTML  = '';
    $('#hbSizeOptions').innerHTML   = '';
    $('#hbColorSection').style.display = 'none';
    $('#hbSizeSection').style.display  = 'none';
    $('#hbPopupLoading').style.display = 'block';
    $('#hbPopupAdd').disabled          = true;
    $('#hbPopupAdd').textContent       = 'Select color & size';
 
    try {
      const res  = await fetch(`/products/${card.dataset.productHandle}.js`);
      popupProduct = await res.json();
      allVariants  = popupProduct.variants;
      buildColorOptions(card.dataset.productId);
    } catch (e) {
      $('#hbPopupLoading').textContent = 'Could not load variants.';
    }
  }
 
  /* ── STEP 1: Build color buttons ── */
  function buildColorOptions(productId) {
    $('#hbPopupLoading').style.display = 'none';
    $('#hbColorSection').style.display = 'block';
 
    /* Shopify option1 = first option (usually Color) */
    const colors = [...new Set(allVariants.map(v => v.option1))];
    const container = $('#hbColorOptions');
    container.innerHTML = '';
 
    colors.forEach(color => {
      /* check if any variant with this color is available */
      const hasAvailable = allVariants.some(v => v.option1 === color && v.available);
 
      const btn = document.createElement('button');
      btn.className   = 'hb-popup__opt-btn hb-popup__color-btn';
      btn.textContent = color;
      btn.dataset.color = color;
      if (!hasAvailable) {
        btn.disabled = true;
        btn.classList.add('is-soldout');
      }
 
      btn.addEventListener('click', () => {
        $$('.hb-popup__color-btn').forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        selectedColor = color;
        selectedSize  = null;
        selectedVariant = null;
        $('#hbSelectedColor').textContent = color;
        $('#hbPopupAdd').disabled    = true;
        $('#hbPopupAdd').textContent = 'Select a size';
        buildSizeOptions(color);
      });
 
      container.appendChild(btn);
    });
  }
 
  /* ── STEP 2: Build size buttons based on selected color ── */
  function buildSizeOptions(color) {
    $('#hbSizeSection').style.display = 'block';
    $('#hbSelectedSize').textContent  = '—';
 
    /* Shopify option2 = second option (usually Size) */
    const sizes = [...new Set(
      allVariants
        .filter(v => v.option1 === color)
        .map(v => v.option2)
    )];
 
    const container = $('#hbSizeOptions');
    container.innerHTML = '';
 
    sizes.forEach(size => {
      const variant = allVariants.find(v => v.option1 === color && v.option2 === size);
      const btn = document.createElement('button');
      btn.className   = 'hb-popup__opt-btn hb-popup__size-btn';
      btn.textContent = size;
      btn.dataset.size = size;
 
      if (!variant || !variant.available) {
        btn.disabled = true;
        btn.classList.add('is-soldout');
      }
 
      btn.addEventListener('click', () => {
        $$('.hb-popup__size-btn').forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        selectedSize    = size;
        selectedVariant = variant;
        $('#hbSelectedSize').textContent = size;
        $('#hbPopupPrice').textContent   = formatMoney(variant.price);
        $('#hbPopupAdd').disabled    = false;
        $('#hbPopupAdd').textContent = '+ Add to Bundle';
      });
 
      container.appendChild(btn);
    });
  }
 
  function closePopup() {
    const overlay = $('#hbPopupOverlay');
    if (overlay) {
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }
    popupProduct = null; allVariants = [];
    selectedColor = null; selectedSize = null; selectedVariant = null;
  }
 
  /* ══════════════════════════════════════════
     BUNDLE LOGIC
  ══════════════════════════════════════════ */
 
  function bindCards() {
    $$('.hb-card', elGrid).forEach(card => {
      const btn = card.querySelector('.hb-card__btn');
      if (!btn || btn.disabled) return;
 
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        if (card.classList.contains('is-selected')) {
          removeProduct(card.dataset.productId);
        } else {
          if (state.selected.length >= BUNDLE_SIZE) {
            showError('Bundle full! Remove a Koofi to swap.');
            return;
          }
          openPopup(card);
        }
      });
    });
 
    /* Bind popup add button */
    document.addEventListener('click', (e) => {
      if (e.target.id === 'hbPopupAdd' && selectedVariant && popupProduct) {
        addProductWithVariant();
        closePopup();
      }
    });
  }
 
  function addProductWithVariant() {
    if (!selectedVariant || !popupProduct) return;
    hideError();
 
    if (state.selected.find(p => p.variantId === String(selectedVariant.id))) {
      showError('This exact size & color is already in your bundle.');
      closePopup();
      return;
    }
 
    const productId = String(popupProduct.id);
 
    state.selected.push({
      id:           productId,
      variantId:    String(selectedVariant.id),
      title:        popupProduct.title,
      color:        selectedColor,
      size:         selectedSize,
      variantTitle: `${selectedColor} / ${selectedSize}`,
      price:        selectedVariant.price,
      image:        popupProduct.featured_image || (popupProduct.images && popupProduct.images[0]) || '',
    });
 
    updateUI();
    pulseSlot(state.selected.length - 1);
  }
 
  function removeProduct(productId) {
    const idx = state.selected.findIndex(p => p.id === productId);
    if (idx !== -1) state.selected.splice(idx, 1);
    hideError();
    updateUI();
  }
 
  /* ── UI ── */
 
  function updateUI() {
    updateCards();
    updateSlots();
    updateProgress();
    updatePricing();
    updateCTA();
    updateMobileBar();
  }
 
  function updateCards() {
    const selectedIds = state.selected.map(p => p.id);
    const atLimit     = state.selected.length >= BUNDLE_SIZE;
    $$('.hb-card', elGrid).forEach(card => {
      const isSel = selectedIds.includes(card.dataset.productId);
      card.classList.toggle('is-selected', isSel);
      card.classList.toggle('is-locked', atLimit && !isSel);
    });
  }
 
  function updateSlots() {
    elSlots.forEach((slot, i) => {
      const p = state.selected[i];
      if (p) {
        slot.classList.remove('hb-slot--empty');
        slot.classList.add('hb-slot--filled');
        slot.innerHTML = `
          <img src="${p.image}" alt="${escHtml(p.title)}" class="hb-slot__img" loading="lazy">
          <div class="hb-slot__info">
            <div class="hb-slot__name">${escHtml(p.title)}</div>
            <div class="hb-slot__variant">${escHtml(p.color)} · Size ${escHtml(p.size)}</div>
            <div class="hb-slot__price">${formatMoney(p.price)}</div>
          </div>
          <button class="hb-slot__remove" data-product-id="${p.id}" aria-label="Remove">&times;</button>
        `;
        slot.querySelector('.hb-slot__remove').addEventListener('click', (e) => {
          e.stopPropagation();
          removeProduct(p.id);
        });
      } else {
        slot.classList.add('hb-slot--empty');
        slot.classList.remove('hb-slot--filled');
        slot.innerHTML = `
          <div class="hb-slot__empty-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="8" x2="12" y2="16"/>
              <line x1="8" y1="12" x2="16" y2="12"/>
            </svg>
          </div>
          <span class="hb-slot__empty-text">Choose a Koofi</span>
        `;
      }
    });
  }
 
  function updateProgress() {
    const count = state.selected.length;
    elProgressFill.style.width = (count / BUNDLE_SIZE * 100) + '%';
    if (count === 0) {
      elProgressText.textContent = `Select 3 products to unlock ${DISCOUNT_PERCENT}% OFF`;
    } else if (count < BUNDLE_SIZE) {
      elProgressText.textContent = `${BUNDLE_SIZE - count} more to unlock ${DISCOUNT_PERCENT}% OFF`;
    } else {
      elProgressText.innerHTML = `<strong>🎉 ${DISCOUNT_PERCENT}% discount unlocked!</strong>`;
    }
  }
 
  function updatePricing() {
    const count    = state.selected.length;
    const total    = state.selected.reduce((s, p) => s + p.price, 0);
    const isBundle = count === BUNDLE_SIZE;
    if (count === 0) {
      elOriginalPrice.textContent = '—';
      elFinalPrice.textContent    = '—';
      elDiscountRow.style.display = 'none';
    } else {
      elOriginalPrice.textContent = formatMoney(total);
      if (isBundle) {
        const disc = Math.round(total * DISCOUNT_PERCENT / 100);
        elDiscountRow.style.display  = 'flex';
        elDiscountAmount.textContent = '−' + formatMoney(disc);
        elFinalPrice.textContent     = formatMoney(total - disc);
      } else {
        elDiscountRow.style.display = 'none';
        elFinalPrice.textContent    = formatMoney(total);
      }
    }
  }
 
  function updateCTA() {
    const ready = state.selected.length === BUNDLE_SIZE;
    elAddToCart.disabled = !ready || state.isLoading;
    if (elCTAText) {
      elCTAText.textContent = ready
        ? 'Add Bundle to Cart'
        : `Select ${BUNDLE_SIZE - state.selected.length} More`;
    }
  }
 
  function updateMobileBar() {
    const count = state.selected.length;
    const total = state.selected.reduce((s, p) => s + p.price, 0);
    elMobileCount.textContent = `${count}/${BUNDLE_SIZE} selected`;
    if (count === BUNDLE_SIZE) {
      elMobilePrice.textContent = formatMoney(total - Math.round(total * DISCOUNT_PERCENT / 100));
    } else if (count > 0) {
      elMobilePrice.textContent = formatMoney(total);
    } else {
      elMobilePrice.textContent = '';
    }
  }
 
  function pulseSlot(i) {
    const slot = elSlots[i];
    if (!slot) return;
    slot.animate(
      [{ transform: 'scale(1)' }, { transform: 'scale(1.04)' }, { transform: 'scale(1)' }],
      { duration: 300, easing: 'ease-out' }
    );
  }
 
  /* ── ERROR ── */
  function showError(msg) {
    elErrorText.textContent = msg;
    elError.style.display   = 'flex';
    elError.style.animation = 'none';
    void elError.offsetWidth;
    elError.style.animation = '';
    setTimeout(hideError, 4000);
  }
  function hideError() { elError.style.display = 'none'; }
 
  /* ── CART ── */
  async function addBundleToCart() {
    if (state.selected.length !== BUNDLE_SIZE) {
      showError(`Please select ${BUNDLE_SIZE} Koofis before adding to cart.`);
      return;
    }
    setLoading(true);
    hideError();
 
    try {
      const items = state.selected.map(p => ({
        id:       parseInt(p.variantId, 10),
        quantity: 1,
        properties: {
          '_Bundle': 'Habibi Koofi Bundle (15% OFF)',
        }
      }));
 
      const res = await fetch('/cart/add.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ items }),
      });
 
      if (!res.ok) {
        const err = await res.json();
        throw new Error(err.description || 'Could not add to cart.');
      }
 
      await fetch('/cart/update.js', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            'bundle_type':     'Habibi Koofi Bundle',
            'bundle_items':    state.selected.map(p => `${p.title} (${p.color}, Size ${p.size})`).join(' | '),
            'bundle_discount': DISCOUNT_PERCENT + '%',
          }
        }),
      });
 
      if (elCTAText) elCTAText.textContent = '✓ Added! Redirecting…';
      elAddToCart.style.background = '#1a6b3a';
      setTimeout(() => {
        window.location.href = '/checkout?discount=HABIBI-BUNDLE-15';
      }, 800);
 
    } catch (err) {
      showError(err.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  }
 
  function setLoading(val) {
    state.isLoading            = val;
    elLoader.style.display     = val ? 'block' : 'none';
    if (elCTAText) elCTAText.style.display = val ? 'none' : 'block';
    elAddToCart.disabled       = val;
    if (elMobileCartBtn) elMobileCartBtn.disabled = val;
  }
 
  function escHtml(str) {
    const d = document.createElement('div');
    d.textContent = str;
    return d.innerHTML;
  }
 
  function bindCTA() {
    if (elAddToCart)     elAddToCart.addEventListener('click', addBundleToCart);
    if (elMobileCartBtn) elMobileCartBtn.addEventListener('click', addBundleToCart);
  }
 
  /* ── INIT ── */
  function init() {
    if (!document.getElementById('habibi-bundle-app')) return;
    cacheElements();
    createPopupHTML();
    bindCards();
    bindCTA();
    updateUI();
    console.log('[Habibi Bundle v3] Color + Size popup initialized ✓');
  }
 
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
 
})();
